<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-field-with-button__container-box"
    [ngClass]="{'common-field-with-button__container-box--error': field.error}"
    [attr.disabled]="isLanding || field.noEditable?true:null">
    <div class="common-field-with-button__block-header">
      <div class="common-text-input__label-no-cursor">
        <span class="common-text-input__text-label">{{field.label}}</span>
        @if (field.required) {
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
          @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
            <tooltip-in-report [inReport]="fieldTypeTask.inReport"></tooltip-in-report>
          }
        </div>
      </div>
      @if (field.description) {
        <div class="common-field-with-button__text-description"
          [innerHTML]="field.description"></div>
      }
    </div>
    <div class="common-field-with-button__buttons-container">
      <button class="common-button__text-little-border"
        [disabled]="isLanding || field.noEditable"
        (click)="createTask()">
        <i class="lf-icon-task common-icon__sm"></i>
        <span class="common-button__text-little-title"
        [afTranslate]="'field-list.create-task'">_Crear tarea</span>
      </button>
    </div>
    @if (fieldTypeTask.taskList?.length) {
      <div class="common-field-with-button__items-block">
        @for (task of fieldTypeTask.taskList; track $index) {
          <div class="common-field-with-button__item-container-list"
            [attr.disabled]="isLanding || field.noEditable?true:null">
            <div class="common-field-with-button__text-container-list">
              <div class="common-field-with-button__info-line-container">
                <span class="common-field-with-button__label-text">
                  <span [afTranslate]="'dashboard.Task'"></span>:
                </span>
                <button class="common-button__link"
                  [disabled]="isLanding"
                  (click)="editTask(task)">
                  <span class="common-button__link-text">{{task.title}}</span>
                </button>
              </div>
              <div class="common-field-with-button__info-line-container">
                <span class="common-field-with-button__label-text">
                  <span [afTranslate]="'common.task-type'"></span>:
                </span>
                <span class="common-field-with-button__value-text">{{task.type}}</span>
              </div>
              <div class="common-field-with-button__info-line-container">
                <span class="common-field-with-button__label-text">
                  <span [afTranslate]="task.taskTypeId === 4?'result-search.participants':'common.users-contacts'"></span>:
                </span>
                @for (participant of task.participants; track $index) {
                  <span class="common-field-with-button__value-text">
                    <span pTooltip="{{participant.fullName?.trim() +' ('+ ('common.inactive-user' | afTranslate)+')'}}"
                      tooltipPosition="bottom"
                      [tooltipDisabled]="!participant.isDeleted">{{participant.fullName?.trim()}}</span>
                    @if (!$last) {
                      <span>, </span>
                    }
                  </span>
                }
              </div>
              @if (task.taskTypeId !== 4 && task.expirationDate) {
                <div class="common-field-with-button__info-line-container">
                  <span class="common-field-with-button__label-text">
                    <span [afTranslate]="'task-edit.expiration-date'"></span>:
                  </span>
                  <span class="common-field-with-button__value-text">{{task.expirationDate | convertDate:'without-time'}}</span>
                </div>
              }
              @if (task.taskTypeId !== 4 && task.repeat) {
                <div class="common-field-with-button__info-line-container">
                  <span class="common-field-with-button__label-text">
                    <span [afTranslate]="'task-list.repeat'"></span>:
                  </span>
                  <span class="common-field-with-button__value-text">{{task.repeat}}</span>
                </div>
              }
              @if (task.taskTypeId === 4) {
                <div class="common-field-with-button__info-line-container">
                  <span class="common-field-with-button__label-text">
                    <span [afTranslate]="'task-list.date-and-hour'"></span>:
                  </span>
                  <span class="common-field-with-button__value-text-childrens">
                    <span>{{task.expirationDate | convertDate:'without-time'}}</span>
                    <span>{{task.beginHour}}</span> -
                    <span>{{task.endHour}}</span>
                  </span>
                </div>
              }
              @if (task.taskTypeId === 4) {
                <div class="common-field-with-button__info-line-container">
                  <span class="common-field-with-button__label-text">
                    <span [afTranslate]="'task-list.modality-and-location'"></span>:
                  </span>
                  <span class="common-field-with-button__value-text-childrens">
                    <span [afTranslate]="task.videoconference?'task-form.videoconference':'task-form.face-to-face'"></span>
                    <span>/</span>
                    <span>{{task.location}}</span>
                  </span>
                </div>
              }
            </div>
            @if (!isLanding && !field.noEditable && fieldTypeTask.userPermissions === 'all') {
              <button class="common-field-with-button__button-action"
                pTooltip="{{'common.remove' | afTranslate}}"
                tooltipPosition="top"
                (click)="deleteTask(task)">
                <i class="lf-icon-trash common-icon__md"></i>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
    </div>
  }
</div>
